import React from 'react';
import { Button } from '@smarterservices/smarter-ui';

interface RefreshButtonProps {
  /**
   * Button size ('small', 'medium', 'large')
   */
  size?: 'small' | 'medium' | 'large';
  
  /**
   * Button color ('primary', 'secondary', etc.)
   */
  color?: string;
}

/**
 * RefreshButton component for refreshing the page
 * 
 * @param {RefreshButtonProps} props - Component props
 * @returns {React.ReactElement} Button component for refreshing the page
 */
const RefreshButton: React.FC<RefreshButtonProps> = ({ 
  size = 'small', 
  color = 'primary' 
}) => {
  return (
    <Button
      size={size}
      color={color}
      onClick={() => window.location.reload()}
      screenReaderLabel="Refresh window"
    >
      Refresh
    </Button>
  );
};

export default RefreshButton;
